<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>

<template>
  <div style="display: inline;">
    <div style="display: inline;">
      <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;" :style="{ background: monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#000355' }">
        <div ref="header" style="padding: 34px 34px  0px  34px;">
          <div class="module-grid" :style="{ background: monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#151599' }" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
            <div style="width: 340px;cursor: pointer;">
              <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" :src="require(monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '@@/assets/img/web/workshop/logo.png' : '@@/assets/img/web/manufacturing/logo.png')" />
            </div>
            <div style="font-weight: 700;font-size: 30px;color: white;">{{ store.state.customer.shortName }}-{{ $t('模具出入库') }}</div>
            <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
              <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
              <div style="display: flex;align-items: center;">
                <yi_data_select v-show="false" :type="'organization'" :ids.sync="orgId"></yi_data_select>
                <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;" :style="{ color: monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#419FFF' : '#ECF5FF' }" icon="yicon yicon-pencil">
                  {{ $t('bianjikanban') }}
                </el-link>
              </div>
            </div>
          </div>
        </div>
        <div style="padding: 0px 14px 34px  14px;">
          <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
            <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
              <component :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId" :monitorSetting="monitorSetting"></component>
            </grid-item>
          </grid-layout>
        </div>
      </div>

      <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
        <setting ref="setting"></setting>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="isShowBoardEdit = false">{{ $t('quxiao') }}</el-button>
          <el-button
            size="mini"
            @click="
              $refs.setting.save();
              isShowBoardEdit = false;
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import setting from '@@/pages/web/monitor/mould_in_out/setting';
import outCount from '@@/pages/web/monitor/mould_in_out/out_count';
import inCount from '@@/pages/web/monitor/mould_in_out/in_count';
import inOrder from '@@/pages/web/monitor/mould_in_out/in_order';
import outOrder from '@@/pages/web/monitor/mould_in_out/out_order';
import VueGridLayout from 'vue-grid-layout';
import { im } from 'mathjs';
export default {
  name: 'web_monitor_mould_in_out_wr_index',
  components: {
    setting: setting,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    outCount: outCount,
    inCount: inCount,
    inOrder: inOrder,
    outOrder: outOrder
  },
  data() {
    return {
      isShowBoardEdit: false,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: []
    };
  },
  created() {
    this.setLayout();
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('SetModelManageLayout', () => {
      this.setLayout();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    this.utils.event_hub.$off('SetModelManageLayout');
  },
  methods: {
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == null) {
        this.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE = 'black';
      }
      if (this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATE == null) {
        this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATE = 'moren';
      }

      console.log(this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATE);
      if (this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATES == null) {
        this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 24,
              h: 3, //应该是6
              i: 'outCount'
            },

            {
              x: 0,
              y: 4,
              w: 24,
              h: 10, //应该是6
              i: 'outOrder'
            },
            {
              x: 0,
              y: 10,
              w: 24,
              h: 3, //应该是6
              i: 'inCount'
            },

            {
              x: 0,
              y: 14,
              w: 24,
              h: 10, //应该是6
              i: 'inOrder'
            }
          ]
        };
      }

      this.layout = this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATES[this.monitorSetting.MACHINE_MODEL_MANAGE_TEMPLATE];
    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        console.log(this.$refs.setting);
        this.$refs.setting.resetData();
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    }
  }
};
</script>
